import type { ApiTravelInsurance } from '@/js/entities/travel-insurance'

import { sendRequest } from '@/js/shared/api'

export const apiTravelInsurance: ApiTravelInsurance = {
  getAllDirections: () =>
    sendRequest({
      url: '/api-entrypoint/vzr/direction/all',
      method: 'GET',
    }),
  getFavoriteDirections: () =>
    sendRequest({
      url: '/api-entrypoint/vzr/direction/favorite',
      method: 'GET',
    }),
  getDirectionLimits: (directions, isYearly) =>
    sendRequest({
      url: '/api-entrypoint/vzr/direction/limits',
      data: {
        directions,
        isYearly,
      },
    }),
  getCalculate: (data) =>
    sendRequest({
      url: '/api-entrypoint/vzr/calculation/calculate',
      data,
    }),
  getProgram: (data) =>
    sendRequest({
      url: '/api-entrypoint/vzr/program/details',
      data,
    }),
  getProgramUpgrade: (data) =>
    sendRequest({
      url: '/api-entrypoint/vzr/calculation/upgrade',
      data,
    }),
  getCalculateTourists: (data) =>
    sendRequest({
      url: '/api-entrypoint/vzr/calculation/tourists',
      data,
    }),
  getCalculateAgreement: (uuid) =>
    sendRequest({
      url: '/api-entrypoint/vzr/calculation/agreement',
      data: {
        uuid,
      },
    }),
  getAgreementSign: (uuid) =>
    sendRequest({
      url: '/api-entrypoint/vzr/agreement/sign',
      data: {
        uuid,
      },
    }),
  getKidAndPolicySample: (uuid) =>
    sendRequest({
      url: '/api-entrypoint/vzr/download/kid',
      data: {
        uuid,
      },
    }),
  getPromocode: (uuid, promocode) =>
    sendRequest({
      url: '/api-entrypoint/vzr/calculation/set-promo-code',
      data: {
        uuid,
        promoCode: promocode,
      },
    }),
  deletePromocode: (uuid) =>
    sendRequest({
      url: '/api-entrypoint/vzr/calculation/unset-promo-code',
      data: {
        uuid,
      },
    }),
  sendIssueStart: (uuid) =>
    sendRequest({
      url: '/api-entrypoint/vzr/calculation/issue-start',
      data: {
        uuid,
      },
    }),
  moveCross: (uuid) =>
    sendRequest({
      url: '/api-entrypoint/vzr/calculation/move-cross',
      data: {
        uuid,
      },
    }),
}

export * from './types'
